<template>
  <rj-tabs v-model="tabsActive">
    <rj-tab-pane label="待审核订单" name="1">
      <invoice-to-be-reviewed />
    </rj-tab-pane>
    <rj-tab-pane label="已审核订单">
      <invoice-has-been-reviewed name="2" />
    </rj-tab-pane>
  </rj-tabs>
</template>

<script>
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import InvoiceToBeReviewed from '@/views/InternationalInvoiceProcessing/InvoiceToBeReviewed.vue';
import InvoiceHasBeenReviewed from '@/views/InternationalInvoiceProcessing/InvoiceHasBeenReviewed.vue';

export default {
  name: 'InternationalInvoiceProcessing',
  components: {
    InvoiceHasBeenReviewed,
    InvoiceToBeReviewed,
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs
  },
  data () {
    return { tabsActive: '1' };
  }
};
</script>

<style scoped>

</style>
